/* eslint-disable sonarjs/cognitive-complexity */
// TODO: remove complexity
import { EmployeePolicyAgreementType } from '../../../types/EmployeeHandbook/employeeHandbookTypes'

/**
 * Sorts an array of EmployeePolicyAgreementType objects in descending order based on the agreedDate property.
 * @param payload - The array of EmployeePolicyAgreementType objects to be sorted.
 * @returns The sorted array of EmployeePolicyAgreementType objects.
 */
export const SortSliceEmployeeAgreementHistory = (
  payload: EmployeePolicyAgreementType[],
): EmployeePolicyAgreementType[] => {
  if (payload.length <= 1) return payload
  return payload.slice().sort((a, b) => {
    const dateAString = a.agreedDate ? a.agreedDate.replace(/IST$/, '') : null
    const dateBString = b.agreedDate ? b.agreedDate.replace(/IST$/, '') : null

    // Place missing dates at the end
    if (!dateAString) return 1
    if (!dateBString) return -1

    const dateA = new Date(dateAString)
    const dateB = new Date(dateBString)

    if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
      // Both dates are valid
      return dateB.getTime() - dateA.getTime() // Sort in descending order
    } else {
      // console.error('Invalid date objects:', dateA, dateB)
      // Place invalid dates at the end
      if (isNaN(dateA.getTime())) return 1
      if (isNaN(dateB.getTime())) return -1
    }

    return 0
  })
}
